import { reactive } from 'vue'
import { defineStore } from 'pinia'
import { Tenant } from '@/types';
import { storeRegistry } from '@/store/storeRegistry'

export const useTenantStore = defineStore('tenantData', () => {
  
  const initialStatsState = {
    data:[]
  }

  const tenants = reactive<Array<Tenant>>([]);

  const tenantData = reactive({ ...initialStatsState });

  function resetStore() {
    Object.assign(tenantData, { data: [] });
  }

  storeRegistry.register('tenantData', resetStore)

  return { tenantData, resetStore, tenants };
})
